import { useAlert, useToast } from "@apex/component-library";
import { Box, Text } from "@chakra-ui/react";
import { AxiosError } from "axios";
import { useParams, useSearchParams } from "react-router-dom";

import { useGetCallsAndAlertsById } from "../../api/useGetCallsAndAlertById";
import { withPermissions } from "../../hoc/withPermissions";
import { Permissions } from "../../permissions";
import displayError from "../../utils/displayError";
import { formatRecord } from "../CallsAlertsResultsGrid/getRecords";
import AuxSkeleton from "./AuxSkeleton";
import CallAlertsAuxWindow, { ViewOptions } from "./CallAlertsAuxWindow";

export interface CallAlertsAuxWindowWrapProps {}

const CallAlertsAuxWindowWrap = (props: CallAlertsAuxWindowWrapProps) => {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const { setAlert } = useAlert();
  const toast = useToast();
  const { data, isLoading } = useGetCallsAndAlertsById(eventId, {
    staleTime: Infinity,
    onError: (error: AxiosError) => {
      displayError(setAlert, toast, error);
    },
  });
  if (isLoading) return <AuxSkeleton />;
  return (
    <Box p={4}>
      <Text as="h4" textStyle="h4" pb={4}>
        Call / Alert Detail
      </Text>
      {data && (
        <CallAlertsAuxWindow
          record={formatRecord(data)}
          defaultView={searchParams.get("select") as ViewOptions}
        />
      )}
    </Box>
  );
};

export default withPermissions(CallAlertsAuxWindowWrap, [
  Permissions.AccountRead,
  Permissions.MarginProcessingUiNavView,
]);
